/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext, useEffect, useRef, useState } from 'react';

import { ContentBody, BodyPrincipal, WrapRec, WrapInput, ContainerLoad } from './styled';

import VideosRow from '../VideosRow';

import SearchThemes from '../Search/Themes';
import SearchCharacteres from '../Search/Characteres';
import SearchInput from '../Search/Input';
import { getScaledValue, Load } from '../../ui/styled';
import {
  ReadKids,
  ReadSearch,
  ReadSearchByCharacter,
  ReadSearchByTheme,
  ReadSerchableCharacteres,
  ReadSerchableThemes,
} from '../../services/catalog';
import { parseVideo } from '../../utils/parser';
import { ReadMyHistory } from '../../services/account';
import { CoreContext } from '../../context/CoreContext';
import { AddSearchHistory, ReadSearchHistory } from '../../services/history';

export default function PageSearch({ wrapped }: { wrapped?: boolean }) {
  const sliderRef = useRef<HTMLElement>(undefined as unknown as HTMLElement);

  const SECTION_SIZE = 3;

  const handleArrowPress = (direction: string, key: number) => {
    const focusSliderVertical = (nextSlide: number) => {
      if (sliderRef.current) {
        const value = getScaledValue(125) * nextSlide;
        sliderRef.current.style.top = `-${value}px`;
      }
    };

    switch (direction) {
      case 'down': {
        const nextSlide = Number(key) + 1;
        if (nextSlide > SECTION_SIZE - 1) return;
        return focusSliderVertical(nextSlide);
      }
      case 'up': {
        const nextSlide = Number(key) - 1;
        if (nextSlide < 0) return;
        return focusSliderVertical(nextSlide);
      }
      default:
        return;
    }
  };

  const { authentication, currentProfile } = useContext(CoreContext);

  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState('');
  const [foundedVideos, setFoundedVideos] = useState<Array<Record<string, unknown>>>([]);

  const search = async (searchExpression: string) => {
    setSearched(searchExpression);
    setLoading(true);
    const result = await ReadSearch(searchExpression);
    if (!currentProfile || !authentication) {
      setLoading(false);
      return;
    }
    const addded = await AddSearchHistory(
      { data: { term: searchExpression } },
      currentProfile.id,
      authentication.jwt,
    );

    if (addded?.id) {
      reloadSearched();
    }

    if (result?.data?.length) {
      setFoundedVideos(
        (currentProfile?.kids
          ? result.data?.filter((f: Record<string, unknown>) =>
              allowedVideos.includes(f.id as number | string),
            )
          : result.data
        ).map(parseVideo),
      );
    } else {
      setFoundedVideos([]);
    }
    setLoading(false);
  };

  const [themes, setThemes] = useState([]);
  const [users, setUsers] = useState([]);
  const [myHistory, setMyHistory] = useState<Array<Record<string, unknown>>>([]);
  const [previousSearchs, setPreviousSearchs] = useState<Array<{ term: string }>>([]);

  const [allowedVideos, setAllowedVideos] = useState<Array<number | string>>([]);

  const init = async () => {
    setLoading(true);
    // const resultThemes = await ReadSerchableThemes()
    // const resultCharacteres = await ReadSerchableCharacteres()
    const resultHistory =
      currentProfile && authentication
        ? await ReadMyHistory(currentProfile.id, authentication.jwt)
        : false;

    if (currentProfile?.kids) {
      const resultKids = await ReadKids();
      // Strapi 5 hoists the collection fields to the entity root and returns
      // stream_shows as a flat array; v4 nested them under attributes + .data.
      const kidsEntry = resultKids?.data?.[0] as Record<string, unknown> | undefined;
      const kidsAttrs = (kidsEntry?.attributes as Record<string, unknown>) ?? kidsEntry;
      const kidsShowsRel = kidsAttrs?.stream_shows as Record<string, unknown> | undefined;
      const kidsShows =
        (kidsShowsRel?.data as Array<Record<string, unknown>>) ??
        (kidsAttrs?.stream_shows as Array<Record<string, unknown>>) ??
        [];
      if (Array.isArray(kidsShows) && kidsShows.length) {
        setAllowedVideos(kidsShows.map((m: Record<string, unknown>) => m.id as number | string));
      }
    }

    // if(resultThemes?.data?.length){ setThemes( resultThemes?.data?.map( item => ({ ...item, title:item?.descriptor }) ) ) ;}
    // if(resultCharacteres?.data?.length){ setUsers( resultCharacteres?.data?.map( item => ({ ...item, image: { uri:item?.picture?.url } }) ) ) ;}
    if (resultHistory?.data?.length) {
      setMyHistory(
        resultHistory?.data
          ?.map((mit: Record<string, unknown>) => mit.stream_show)
          ?.map(parseVideo),
      );
    }

    await reloadSearched();

    setLoading(false);
  };

  const reloadSearched = async () => {
    const resultPrevious =
      currentProfile && authentication
        ? await ReadSearchHistory(currentProfile.id, authentication.jwt)
        : false;
    if (resultPrevious?.data?.length) {
      setPreviousSearchs(
        resultPrevious?.data
          ?.sort(
            (a: Record<string, unknown>, b: Record<string, unknown>) =>
              new Date(b?.createdAt as string).getTime() -
              new Date(a?.createdAt as string).getTime(),
          )
          ?.filter(
            (fit: Record<string, unknown>, fik: number) => fit.term && fik < 5,
          ) as Array<{ term: string }>,
      );
    }
  };

  const searchBy = async (type: string, item: Record<string, unknown>) => {
    setLoading(true);

    const itemTitle = (item.title ?? item.name ?? '') as string;
    const itemId = item.id as number | string;
    setSearched(itemTitle);
    const result =
      type === 'theme' ? await ReadSearchByTheme(itemId) : await ReadSearchByCharacter(itemId);
    if (!currentProfile || !authentication) {
      setLoading(false);
      return;
    }
    await AddSearchHistory(
      { data: { [type === 'theme' ? 'themes' : 'characters']: itemId } },
      currentProfile.id,
      authentication.jwt,
    );

    if (result?.data?.length) {
      setFoundedVideos(result.data.map(parseVideo));
    } else {
      setFoundedVideos([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    init();
  }, [currentProfile]);

  return (
    <>
      <ContentBody ref={sliderRef}>
        {loading ? (
          <ContainerLoad>
            <Load marginLeft />
          </ContainerLoad>
        ) : (
          <BodyPrincipal wrapped={wrapped}>
            <WrapInput>
              <SearchInput
                searched={searched}
                wrapped={wrapped}
                onSearch={search}
                lastSearch={previousSearchs}
              />
            </WrapInput>
            <WrapRec wrapped={wrapped}>
              {searched ? (
                <VideosRow
                  title={
                    foundedVideos?.length
                      ? `Resultados para: ${searched}`
                      : `Sem resultados para: ${searched}`
                  }
                  videos={foundedVideos}
                  handleVertical={(a: string) => handleArrowPress(a, 0)}
                />
              ) : (
                <>
                  {/* <SearchThemes themes={themes} handleVertical={a => handleArrowPress(a, 0)} searchBy={searchBy}  /> */}
                  {/* <SearchCharacteres users={users} handleVertical={a => handleArrowPress(a, 1)} searchBy={searchBy} />  */}
                  {!myHistory?.length ? null : (
                    <VideosRow
                      title={'Últimos visualizados'}
                      handleVertical={(a: string) => handleArrowPress(a, 0)}
                      videos={myHistory}
                    />
                  )}
                </>
              )}
            </WrapRec>
          </BodyPrincipal>
        )}
      </ContentBody>
    </>
  );
}
